'use strict';

var $ = require('jquery');

module.exports = function () {
    $(document).ready(function () {
        const observePopover = () => {
            // Já existe? então adiciona evento direto
            if ($('[data-toggle="popover-jau"]').length > 0) {
                bindPopoverEvents();
                return;
            }

            // Caso contrário, observa o DOM até aparecer
            const observer = new MutationObserver((mutations, obs) => {
                if ($('[data-toggle="popover-jau"]').length > 0) {
                    bindPopoverEvents();
                    obs.disconnect();
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        };

        const bindPopoverEvents = () => {

            $(document).off('click.popoverJau').on('click.popoverJau', '[data-toggle="popover-jau"]', function (e) {
                e.preventDefault();
                e.stopPropagation();

                const $popover = $(this).siblings('.block-content-popover');

                $('.block-content-popover').not($popover).hide();

                const isHidden = $popover.css('display') === 'none';
                $popover.css('display', isHidden ? 'flex' : 'none');
            });

            $(document).off('click.popoverJauOutside').on('click.popoverJauOutside', function () {
                $('.block-content-popover').hide();
            });
        };

        observePopover();
    });
};
